import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { AppLandingPage } from "@myplant-io/app-landing-page";
import "@myplant-io/app-landing-page/index.css";
import { AILogoPos, AILogoNeg } from "@myplant-io/logos";
import { RouteNames } from "../RouteNames";
import { useSnackbar } from "@myplant-io/snackbar";
import { defineMessages, useIntl } from "react-intl";
import { useAuth, usePublicAppByName } from "@myplant-io/hooks";
import { useMediaQuery, useTheme } from "@mui/material";
import { API_BASE_URL } from "../constants";

const messages = defineMessages({
  unauthorized: {
    id: "upstream.error.not-allowed",
    defaultMessage: "You are not allowed to access this page.",
  },
});

export function LandingPage() {
  const { formatMessage, locale } = useIntl();
  const {
    data: authData,
    isFetched: isAuthFetched,
    isLoading: isAuthLoading,
    isError: isAuthError,
  } = useAuth(API_BASE_URL);
  const user = authData?.user;
  const navigate = useNavigate();
  const { showErrorMessage } = useSnackbar();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const { data, isLoading } = usePublicAppByName({
    wsBaseUrl: "/ws",
    appName: "WEB_ASSISTANT",
    language: locale,
  });
  const login = () => {
    navigate(RouteNames.LOGIN);
  };

  useEffect(() => {
    if (isAuthFetched && !isAuthLoading && !isAuthError && !user?.name) {
      showErrorMessage({
        message: formatMessage(messages.unauthorized),
        disableClickAway: true,
      });
    }
  }, [
    formatMessage,
    isAuthError,
    isAuthFetched,
    isAuthLoading,
    showErrorMessage,
    user?.name,
  ]);

  if (user?.name) {
    return <Navigate to={RouteNames.CHAT} />;
  }

  return (
    <AppLandingPage
      mainContentStyle={{
        minHeight: "700px",
      }}
      loading={isLoading || !isAuthFetched}
      titleProps={{
        first: data?.name ?? "",
        second: data?.shortDescription ?? "",
        size: isSmallScreen ? "sm" : "md",
      }}
      titleContainerStyle={{
        marginTop: isSmallScreen ? "8rem" : "20rem",
      }}
      productSuiteLogos={{
        lightTheme: <AILogoPos />,
        darkTheme: <AILogoNeg />,
      }}
      wallpaperProps={{
        urls: {
          xs: {
            default:
              "https://myplant.io/myplant-io-public/landing-page/xs/landing-page-ai.jpg",
          },
          sm: {
            default:
              "https://myplant.io/myplant-io-public/landing-page/1:2/landing-page-ai.jpg",
          },
        },
        style: {
          objectPosition: "top right",
        },
        containerStyle: {
          minHeight: "40vh",
        },
      }}
      onLogin={login}
    />
  );
}
